module.exports = __webpack_public_path__ + "img/1440.bfb5e73c.jpg";